import { NetYieldBuildingDetailReadModel } from '@client/api';
import i18n from 'i18next';
import dayjs from 'dayjs';

export const transformToExcelFormat = (
  data: NetYieldBuildingDetailReadModel[],
  selectedRows: Set<string>,
  selectedPeriod: string,
): Record<string, unknown>[] => {
  if (data.length === 0) return [{ [i18n.t('noData', { ns: 'reporting' })]: null }];

  return data
    .filter((item) => selectedRows.size === 0 || selectedRows.has(item.spaceId))
    .map((item) => ({
      [i18n.t('netYield.building', { ns: 'reporting' })]: item.name,
      [i18n.t('netYield.operationalCost', { ns: 'reporting' })]: item.operatingCost ?? null,
      [i18n.t('netYield.netIncome', { ns: 'reporting' })]: item.netIncomeAmount?.amount ?? null,
      [i18n.t('netYield.propertyValue', { ns: 'reporting' })]: item.propertyValue ?? null,
      [i18n.t('netYield.netYieldYear', { ns: 'reporting', year: dayjs(selectedPeriod).year() })]: item.netYield ?? null,
      [i18n.t('netYield.netYieldYear', { ns: 'reporting', year: dayjs(selectedPeriod).subtract(1, 'year').year() })]:
        item.previousNetYield ?? null,
      [i18n.t('netYield.netYieldLastTwelveMonths', { ns: 'reporting' })]: item.percentChange ?? null,
    }));
};
